module.exports = __webpack_public_path__ + "img/EgyptTechCamelRiderS_ua.7f4f5446.webp";